'use strict';

var debounce = require('lodash/debounce');
var scrollInfo = {
    location: $(window).scrollTop(),
    loadMore: 0,
    loadPrev: 0,
    isLoading: false,
    maxVal: 0,
    curPage: 0,
    unloadedAbove: 0,
    prevScroll: 0
};

var pageSize = $('.grid-footer').first().data('pageSize') || 24;

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

/**
 * Function for calculating the scroll location at which to trigger load of the next section
 * @returns {number} scroll location at which to trigger load of the next section
 */
function calculateLoadMoreThreshold() {
    var almostLastTileTop = $('.tile-page-wrapper > .row').offset().top;
    // .grid-footer is inserted at the end of every "page" of results from Search-UpdateGrid
    // so we are ready to load more when the 4 to last tile (grid-item) top reaches the container top
    if ($('.tile-page-wrapper > .row > .grid-footer:last').prevAll('.grid-item').eq(4).length) {
        almostLastTileTop = $('.tile-page-wrapper > .row > .grid-footer:last').prevAll('.grid-item').eq(4).offset().top;
    }
    var containerTop = $('.tile-page-wrapper > .row').offset().top;
    return (almostLastTileTop - containerTop);
}

/**
 * Function for calculating the scroll location at which to trigger load of the previous section
 * @returns {number} scroll location at which to trigger load of the previous section
 */
function calculateLoadPrevThreshold() {
    return $('.tile-page-wrapper > .row:first').children('.grid-item:first').offset().top;
}

/**
 * Function to contain the conditions for loading the next section
 * @param {number} curScroll current scroll position
 * @returns {boolean} bool for whether or not the next section should be loaded
 */
function shouldLoadMore(curScroll) {
    var maxValStr = $('.js-change-num').text();
    maxValStr = maxValStr.replace(',', '');
    scrollInfo.maxVal = Number(maxValStr);
    scrollInfo.loadMore = calculateLoadMoreThreshold();

    var notLoading = !scrollInfo.isLoading;
    var hasMorePages = (scrollInfo.curPage + 1) * pageSize < scrollInfo.maxVal;
    var scrolledPastLoadMore = curScroll > scrollInfo.loadMore;
    var scrolledDown = curScroll > scrollInfo.prevScroll;
    var shouldLoad = notLoading && hasMorePages && scrolledPastLoadMore && scrolledDown;
    return shouldLoad;
}

/**
 * Function to contain the conditions for loading the previous section
 * @param {number} curScroll current scroll position
 * @returns {boolean} bool for whether or not the previous section should be loaded
 */
function shouldLoadPrev(curScroll) {
    var maxValStr = $('.js-change-num').text();
    maxValStr = maxValStr.replace(',', '');
    scrollInfo.maxVal = Number(maxValStr);
    scrollInfo.loadPrev = calculateLoadPrevThreshold();
    return !scrollInfo.isLoading && scrollInfo.unloadedAbove > -1 && curScroll < scrollInfo.prevScroll && curScroll < scrollInfo.loadPrev;
}

/**
 * Function to calculate the current page of results being viewed by the user
 * @param {number} curScroll current scroll position
 */
function updateCurrentPagination(curScroll) {
    var curPage = scrollInfo.unloadedAbove;

    $('.tile-page-wrapper > .row > .grid-footer').each(function () {
        if ($(this).prevUntil('.infinite-scroll-prev').length) {
            if (curScroll > $(this).prevUntil('.infinite-scroll-prev').last().offset().top) {
                curPage += 1;
            }
        }
    });

    if (curPage !== scrollInfo.curPage) {
        var curWindowUrl = new URL(document.location);
        if (curPage > 0) {
            curWindowUrl.searchParams.set('start', curPage * pageSize);
        } else {
            curWindowUrl.searchParams.delete('start');
        }

        window.history.pushState(scrollInfo, '', curWindowUrl.toString());
        scrollInfo.curPage = curPage;
    }
}

/**
 * Handler for the scroll event
 * @param {Object} e event triggering the function
 */
function checkScroll(e) {
    var curScroll = $(window).scrollTop();
    updateCurrentPagination(curScroll);
    var spinnerContainer = '';

    if (shouldLoadMore(curScroll)) {
        scrollInfo.isLoading = true;
        spinnerContainer = $('.tile-page-wrapper > .grid-spinner:last');
        spinnerContainer.spinner().show();
        var showMoreUrl = $('.tile-page-wrapper > .row > .grid-footer:last .infinite-scroll-next').data('url');
        if (!showMoreUrl) {
            spinnerContainer.spinner().hide();
            scrollInfo.isLoading = false;
            return;
        }
        $(this).trigger('search:showMore', e);
        $.ajax({
            url: showMoreUrl,
            data: { selectedUrl: showMoreUrl },
            method: 'GET',
            success: function (response) {
                $('.tiles-container').append(response);
                updateSortOptions(response);
                spinnerContainer.spinner().hide();
                $('body').trigger('pagination:update');
                setTimeout(function () {
                    scrollInfo.loadMore = calculateLoadMoreThreshold();
                    scrollInfo.isLoading = false;
                }, 1000);
            },
            error: function () {
                spinnerContainer.spinner().hide();
                scrollInfo.isLoading = false;
            }
        });
    } else if (shouldLoadPrev(curScroll)) {
        scrollInfo.isLoading = true;
        spinnerContainer = $('.tile-page-wrapper > .grid-spinner:first');
        spinnerContainer.spinner().show();
        var showPrevUrl = $('.infinite-scroll-prev:first').data('url');
        if (!showPrevUrl) {
            spinnerContainer.spinner().hide();
            scrollInfo.isLoading = false;
            return;
        }
        $(this).trigger('search:showMore', e);
        $.ajax({
            url: showPrevUrl,
            data: { selectedUrl: showPrevUrl },
            method: 'GET',
            success: function (response) {
                $('.tiles-container').prepend(response);
                updateSortOptions(response);
                spinnerContainer.spinner().hide();
                $('body').trigger('pagination:update');
                setTimeout(function () {
                    scrollInfo.loadPrev = calculateLoadPrevThreshold();
                    scrollInfo.loadMore = calculateLoadMoreThreshold();
                    scrollInfo.unloadedAbove -= 1;
                    $('.tile-page-wrapper > .row > .grid-footer:first').prevAll('.grid-item').get(0).scrollIntoView();
                    scrollInfo.isLoading = false;
                }, 1000);
            },
            error: function () {
                spinnerContainer.spinner().hide();
                scrollInfo.isLoading = false;
            }
        });
    }
    scrollInfo.prevScroll = curScroll;
}

var exports = {
    infiniteScroll: function () {
        // Start scrollinfo init
        var curWindowUrl = new URL(document.location);
        if (curWindowUrl.searchParams.has('start')) {
            scrollInfo.curPage = curWindowUrl.searchParams.get('start') / pageSize;
        } else {
            scrollInfo.curPage = 0;
        }

        scrollInfo.unloadedAbove = scrollInfo.curPage - 1;

        scrollInfo.loadMore = calculateLoadMoreThreshold();
        scrollInfo.loadPrev = calculateLoadPrevThreshold();
        // End scrollinfo init

        if (!$('.search-pagination').is('*')) {
            if ('scrollRestoration' in history) {
                history.scrollRestoration = 'manual';
            }
            $(window).on('scroll', debounce(function (e) {
                checkScroll(e);
            }, 50));
        }
    },
    nextPage: function () {
        // Show more products
        if ($('.search-pagination').is('*')) {
            $('.container').on('click', 'button.page-link', function (e) {
                e.stopPropagation();
                var showMoreUrl = $(this).data('url');
                e.preventDefault();
                $.spinner().start();
                $(this).trigger('search:showMore', e);
                $.ajax({
                    url: showMoreUrl,
                    data: { selectedUrl: showMoreUrl },
                    method: 'GET',
                    success: function (response) {
                        $('.tiles-container').empty().html(response);
                        updateSortOptions(response);
                        $.spinner().stop();
                        $('.js-tile-wrapper')
                            .get(0)
                            .scrollIntoView(false);
                        $('body').trigger('pagination:update');
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            });
        }
    },
    tileClick: function () {
        $('body').on('click', '.js-tile-wrapper', function () {
            var backUrl = $(this).data('pagingUrl');
            history.replaceState(
                'paginatedBack',
                document.title,
                backUrl
            );
            var scrollBackData = {
                pid: $(this).data('pid'),
                catUrl: backUrl
            };
            localStorage.setItem('scrollBackTo', JSON.stringify(scrollBackData));
        });
    },
    scrollBack: function () {
        var scrollBackData = JSON.parse(localStorage.getItem('scrollBackTo'));
        if (window.location.href === scrollBackData.catUrl) {
            $('.js-tile-wrapper[data-pid=' + scrollBackData.pid + ']')
                .get(0)
                .scrollIntoView(false);
        }
    }
};

module.exports = exports;
